import { Flex, Box, Container } from "@chakra-ui/react";

import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import HeaderSidebarMobile from "./HeaderSidebarMobile";
import useSmallScreen from "@/utils/UseDeviceSize";

const Layout = ({ children, handleSetIsAuthenticated }: any) => {
    const isSmallScreen = useSmallScreen();

    return (
        <Flex height="100vh" width="100%">
            {!isSmallScreen && <Sidebar />}
            <Box
                display="flex"
                flexDirection="column"
                bgColor="#f8fafc"
                width={isSmallScreen ? "100%" : "calc(100% - 350px)"}
                overflowY="auto"
            >
                {isSmallScreen
                    ? <HeaderSidebarMobile handleSetIsAuthenticated={handleSetIsAuthenticated} />
                    : <Header handleSetIsAuthenticated={handleSetIsAuthenticated} />
                }
                <Container flex="1" py={4} px={isSmallScreen ? 0 : 4} maxWidth='none' overflowX="auto">
                    {children}
                </Container>
                <Footer />
            </Box>
        </Flex>
    );
}

export default Layout;
